'use client'

import { createContext } from 'react'

const URLContext = createContext<string>('http://localhost:3000/')

export { URLContext }
